<div fxLayout="column" fxFlex="100">
  <mat-card class="mb-3">
    <mat-card-header class="pb-3">
      <mat-card-title>
        Integrations brugere
      </mat-card-title>
    </mat-card-header>
  </mat-card>

  <div>
    <div fxLayout="column" fxFlex="35">
      <mat-card class="mb-3">
        <mat-card-content class="customer-integration-users-header">
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex="40">Navn</div>
            <div fxFlex="60" fxLayoutAlign="end center">
              <button mat-icon-button aria-label="Opret integrations bruger" (click)="newUser()">
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      @for (user of users$ | async; track user) {
        <mat-card class="mb-2">
          <mat-card-content>
            <div fxLayout="row" fxLayoutAlign="start center">
              <div fxFlex="40">{{user.username}}</div>
              <div fxFlex="60" fxLayoutAlign="end center">
                <button mat-icon-button (click)="editUser(user)">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      }
    </div>
  </div>
</div>
